import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import IrrigationSystem from "../../components/irrigation-system/IrrigationSystem";

function IrrigationSystemPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Irrigation System | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Irrigation System"} t={t} />
      <IrrigationSystem />
    </>
  );
}

export default IrrigationSystemPage;
